import { Event } from 'types/common';
import { styled } from '@mui/material/styles';
import MuiLoader from './Loader';
import { Stack } from '@mui/material';
import NoResults from './NoResultsText';

interface ListProps {
    data: Event[];
    loading?: boolean;
    showLoading?: boolean;
    children: (event: Event, index: number) => any;
    noResultProps?: any;
    loaderProps?: any;
}

const List = ({ data, loading = false, children, showLoading, noResultProps, loaderProps }: ListProps) => {
    if (showLoading && loading) {
        return <MuiLoader loading={loading} {...loaderProps} />;
    }
    if (loading) {
        return null;
    }
    return (
        <div>
            {!data?.length && <NoResults {...noResultProps} message="No Results Found!" />}
            {!!data?.length &&
                data.map((event, index) => {
                    return children(event, index);
                })}
        </div>
    );
};

export default List;
